module.exports = __webpack_public_path__ + "media/images/application2/AppPublisher__sns-share__buttons-60e408ce0ccffbdf3699208ac572316a.svg";